<template>
  <div class="content">
    <div class="breadcrumb">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item>加盟</el-breadcrumb-item>
        <el-breadcrumb-item>学员中心</el-breadcrumb-item>
      </el-breadcrumb>
      <div class="button-wrap">
        <el-button type="primary"
                   size="small"
                   @click="handleToCreate">新建</el-button>
      </div>
    </div>
    <el-card style="margin-top: 20px; padding-top: 20px">
      <el-form class="search-wrap"
               ref="searchForm"
               :inline="true"
               :model="query"
               size="small"
               label-position="left">
        <el-form-item label="学员信息">
          <el-input v-model.trim="query.user_keyword"
                    placeholder="手机号/姓名"
                    @input="getList(true)"
                    clearable></el-input>
        </el-form-item>
        <el-form-item label="年级">
          <el-select v-model="query.apply_year"
                     placeholder="请选择年级"
                     clearable
                     @change="getList(true)"
                     style="width: 150px">
            <el-option label="不限"
                       value=""></el-option>
            <el-option label="2022年"
                       value="2022"></el-option>
            <el-option label="2023年"
                       value="2023"></el-option>
            <el-option label="2024年"
                       value="2024"></el-option>
            <el-option label="2025年"
                       value="2025"></el-option>
            <el-option label="2026年"
                       value="2026"></el-option>
            <el-option label="2027年"
                       value="2027"></el-option>

            <el-option label="2028年"
                       value="2028"></el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </el-card>
    <el-card style="margin-top: 20px">
      <div class="card-header">
        <TableTittle :tittle="TableName"></TableTittle>

      </div>
      <el-table :data="tableData"
                :header-cell-style="{
          textAlign: 'center',
          color: '#909399',
          fontFamily: 'PingFang SC',
          fontSize: '14px',
          fontWeight: '400',
          backgroundColor: '#F2F6FC',
        }"
                :cell-style="{ textAlign: 'center', fontSize: '13px' }"
                border
                @selection-change="handleSelectionChange">

        <el-table-column label="序号"
                         width="64"
                         align="center">
          <template slot-scope="scope">
            {{ pageTotal - (query.pageIndex - 1) * query.pageSize - scope.$index }}
          </template>
        </el-table-column>
        <el-table-column prop="realname"
                         label="姓名"
                         show-overflow-tooltip>

          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="showContactInfo(scope.row)">
              {{ scope.row.realname }}
            </el-link>
          </template>
        </el-table-column>
        <el-table-column prop="phone"
                         label="手机号"
                         width="200"></el-table-column>
        <el-table-column prop="apply_year"
                         label="年级">
          <template slot-scope="scope"> {{ scope.row.apply_year }}级</template>
        </el-table-column>
        <el-table-column prop="apply_year"
                         label="创建人">
          <template slot-scope="scope"> {{scope.row.creator? scope.row.creator.alias:'--' }}</template>
        </el-table-column>
        <el-table-column label="创建时间"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ $moment(scope.row.create_time).format("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column label="更新时间"
                         show-overflow-tooltip>
          <template slot-scope="scope">
            {{ $moment(scope.row.update_time).format("YYYY-MM-DD HH:mm") }}
          </template>
        </el-table-column>
        <el-table-column fixed="right"
                         label="操作"
                         min-width="100">
          <template slot-scope="scope">
            <el-link type="primary"
                     :underline="false"
                     @click="handleToEdit(scope.row.id)">编辑</el-link>
            <el-link type="primary"
                     :underline="false"
                     @click="handleRecord(scope.row)">记录</el-link>
            <el-link type="danger
            "
                     @click="handleOpenCourse(scope.row)"
                     :underline="false">开课</el-link>
          </template>
        </el-table-column>
      </el-table>
      <div style="margin-top: 16px">

        <div class="block">
          <el-pagination background
                         layout="total,prev, pager, next, sizes, jumper"
                         :current-page="Number(query.pageIndex)"
                         :page-sizes="[10, 20, 50, 100, 500]"
                         :page-size="Number(query.pageSize)"
                         :total="Number(pageTotal)"
                         @size-change="handleSizeChange"
                         @current-change="handleCurrentChange"></el-pagination>
        </div>
      </div>
    </el-card>

    <ConfirmCollege :isVisible="confirmDialog"
                    :content="confirmContent"
                    @close="confirmDialog = false"
                    @submit="getList()" />
    <ChangeStatus :isVisible="changeDialog"
                  :content="changeContent"
                  @close="changeDialog = false"
                  @submit="getList()" />
    <Service :isVisible="serviceDialog"
             :content="serviceContent"
             @close="serviceDialog = false"
             @submit="getList()" />
    <OpenCourse :visible="openCourseDialog"
                :editRow="editRow"
                @close="openCourseDialog=false"></OpenCourse>
    <AddStudent :visible.sync="addDailogVisible"
                @success="getList()"
                @close="addDailogVisible=false" />
    <EditStudent :visible.sync="editDialogVisible"
                 :student-id="currentStudentId"
                 @success="getList()"
                 @close="editDialogVisible = false" />
    <record :visible.sync="recordVisible"
            :editRow="editRow"
            @close="recordVisible = false"></record>
    <el-dialog title="联系方式"
               :visible.sync="contactDialogVisible"
               width="400px">
      <el-descriptions :column="1"
                       border>
        <el-descriptions-item label="学生姓名">{{ contactInfo.realname }}</el-descriptions-item>
        <el-descriptions-item label="手机号">{{ contactInfo.phone || '-' }}</el-descriptions-item>
        <el-descriptions-item label="微信号">{{ contactInfo.wechat || '-' }}</el-descriptions-item>
        <el-descriptions-item label="QQ号">{{ contactInfo.qq || '-' }}</el-descriptions-item>
      </el-descriptions>
      <span slot="footer"
            class="dialog-footer">
        <el-button @click="contactDialogVisible = false">关 闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import TableTittle from '../../../components/TableTittle/TableTittle.vue'

import ConfirmCollege from '@/components/DialogComponents/DataInventoryStudent/ConfirmCollege.vue'
import ChangeStatus from '@/components/DialogComponents/DataInventoryStudent/ChangeStatus.vue'
import Service from '@/components/DialogComponents/DataInventoryStudent/Service.vue'
import { studentBasiclist } from '@/request/api'
import OpenCourse from '../../../components/DialogComponents/warrant/openCourse.vue'
import AddStudent from '../../../components/DialogComponents/warrant/AddStudent.vue'
import EditStudent from '../../../components/DialogComponents/warrant/editStudent.vue'
import record from '../../../components/DialogComponents/warrant/record.vue'
export default {
  components: {
    TableTittle,
    ConfirmCollege,
    ChangeStatus,
    Service,
    OpenCourse,
    AddStudent,
    EditStudent,
    record,
  },
  data() {
    return {
      recordVisible: false,
      contactDialogVisible: false,
      contactInfo: {},
      editDialogVisible: false,
      addDailogVisible: false,
      dialogFormVisible: false,
      currentStudentId: '',
      companyForm: {
        company_normal_course_ids: [],
      },
      rules: {
        company_normal_course_ids: [
          { required: true, message: '请选择开通课程', trigger: 'blur' },
        ],
      },
      TableName: '学员列表',
      query: {
        pageIndex: 1,
        pageSize: 10,
        isPaging: 1,
        cid: localStorage.getItem('cid'),
        basic_archive: '0',
      },
      pageTotal: 0,
      tableData: [],
      confirmDialog: false,
      confirmContent: {},
      changeContent: {},
      changeDialog: false,
      serviceDialog: false,
      serviceContent: {},
      filters: {
        course_status: [
          { label: '等待上课', value: 1 },
          { label: '正在上课', value: 2 },
          { label: '课程结束', value: 3 },
          { label: '课程终止', value: 4 },
        ],
        student_sync_statuses: [
          { label: '待对接', value: 1 },
          { label: '待分配', value: 2 },
          { label: '匹配中', value: 3 },
          { label: '上课中', value: 4 },
          { label: '已终止', value: 5 },
          { label: '已结束', value: 6 },
        ],
      },
      receiver_update_time: '',
      apply_time: '',
      chooseList: [],
      lock: true,
      sum_receive_amount: 0,
      editRow: null,
      openCourseDialog: false,
    }
  },
  watch: {
    // 时间数据监听
    receiver_update_time(value) {
      if (value) {
        this.query.start_receiver_update_time = this.$moment(value[0]).valueOf()
        this.query.end_receiver_update_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_receiver_update_time = ''
        this.query.end_receiver_update_time = ''
        this.getList(true)
      }
    },
    // 时间数据监听
    apply_time(value) {
      if (value) {
        this.query.start_apply_time = this.$moment(value[0]).valueOf()
        this.query.end_apply_time = this.$moment(value[1]).valueOf()
      } else {
        this.query.start_apply_time = ''
        this.query.end_apply_time = ''
        this.getList(true)
      }
    },
  },
  filters: {},
  mounted() {
    // this.parseQuery()
    this.$store.dispatch('getAllColleges')
    this.$store.dispatch('getStaffList')
    this.$store.dispatch('fetchCityList')
    this.$store.dispatch('getProducts')
    this.$store.dispatch('getServiceSubjectDictionary')
    this.$store.dispatch('fetchNormalCourse')
    this.getList()
  },
  methods: {
    showContactInfo(row) {
      this.contactInfo = {
        realname: row.realname,
        phone: row.phone,
        wechat: row.wechat,
        qq: row.qq,
      }
      this.contactDialogVisible = true
    },
    handleOpenCourse(row) {
      this.editRow = row
      this.openCourseDialog = true
    },

    handleToCalendar(row) {
      this.$router.push(`/product/calendar?student_id=${row.id}`)
    },
    handleSizeChange(val) {
      this.query.pageSize = val
      this.getList()
    },
    handleCurrentChange(val) {
      this.query.pageIndex = val
      this.getList()
    },
    getList(isReset = false) {
      if (isReset) {
        this.$set(this.query, 'pageIndex', 1)
      }
      const params = Object.assign({}, this.query)
      if (params.product_ids) {
        params.product_ids = params.product_ids.join(',')
      }
      if (params.service_subject_ids) {
        params.service_subject_ids = params.service_subject_ids.join(',')
      }
      if (params.product_watchers) {
        params.product_watchers = params.product_watchers.join(',')
      }
      if (['暂未定校', '未定校', '无'].includes(params.college_keyword)) {
        params.college_keyword = 'null'
      }
      if (
        ['暂未确定', '未确定', '无'].includes(params.service_subjects_keyword)
      ) {
        params.service_subjects_keyword = 'null'
      }
      if (params.student_sync_statuses) {
        params.student_sync_statuses = params.student_sync_statuses.join(',')
      }
      studentBasiclist(params).then((res) => {
        this.tableData = res.data.list || []
        this.pageTotal = res.data.count
        this.sum_receive_amount = res.data.sum_receive_amount
      })
      this.syncQuery()
    },
    // 同步URL请求参数
    syncQuery() {
      const params = Object.assign({}, this.query)
      if (params.product_ids) {
        params.product_ids = params.product_ids.filter((v) => v).join(',')
      }
      if (params.service_subject_ids) {
        params.service_subject_ids = params.service_subject_ids
          .filter((v) => v)
          .join(',')
      }
      if (params.student_sync_statuses) {
        params.student_sync_statuses = params.student_sync_statuses.join(',')
      }
      let isSync = Object.keys(params).some(
        (key) => this.$route.query[key] != params[key]
      )
      isSync &&
        this.$router.replace({
          query: Object.assign({}, this.$route.query, params),
        })
    },
    // 解析URL请求参数
    parseQuery() {
      Object.keys(this.$route.query).forEach((key) => {
        this.query[key] = this.$route.query[key]
      })
      if (this.query.product_ids && this.query.product_ids.length) {
        this.query.product_ids = this.query.product_ids.split(',').map((v) => {
          return Number(v)
        })
      }
      if (
        this.query.service_subject_ids &&
        this.query.service_subject_ids.length
      ) {
        this.query.service_subject_ids = this.query.service_subject_ids
          .split(',')
          .map((v) => {
            return Number(v)
          })
      }
      if (
        this.query.student_sync_statuses &&
        this.query.student_sync_statuses.length
      ) {
        this.query.student_sync_statuses = this.query.student_sync_statuses
          .split(',')
          .map((v) => {
            return Number(v)
          })
      }
      this.query.follow = Number(this.query.follow)
      this.query.pageIndex = Number(this.query.pageIndex)
      if (this.query.start_apply_time && this.query.end_apply_time) {
        this.createDatetime = [
          this.$moment(Number(this.query.start_apply_time)),
          this.$moment(Number(this.query.end_apply_time)),
        ]
      }
    },
    handleToCreate() {
      this.addDailogVisible = true
    },
    service_subjectsFormate(value) {
      if (value && value.length) {
        let val = JSON.parse(value)
        let map_val = val.map((v) => {
          return `（${v.subject_code}）${v.subject_name}`
        })
        return map_val.join(',')
      } else {
        return '暂无服务科目'
      }
    },
    consult_teacherFormate(value) {
      if (value) {
        return value.alias
      } else {
        return '无'
      }
    },
    collegeFormate(row) {
      if (row.is_choose) {
        return `${row.apply_college_name},（${row.apply_major_code}）${row.apply_major_name}`
      } else {
        return '暂无定校'
      }
    },
    product_watchersFormate(value) {
      if (value && value.length) {
        let map_val = value.map((v) => {
          return v.alias
        })
        return map_val.join(',')
      } else {
        return '无'
      }
    },
    handleToEdit(id) {
      this.currentStudentId = id
      this.editDialogVisible = true
    },
    handleRecord(row) {
      this.editRow = row
      this.recordVisible = true
    },
    handleToConfirm(row) {
      this.confirmContent = Object.assign(row, {})
      this.confirmDialog = true
    },
    handleToService(row) {
      this.serviceContent = Object.assign(row, {})
      this.serviceDialog = true
    },
    handleToDeliver(row) {
      window.open(
        `#/dataInventory/student/deliverlist?student_id=${row.id}&student_name=${row.realname}`
      )
      // this.$router.push(
      //   `/dataInventory/student/deliverlist?student_id=${row.id}&student_name=${row.realname}`
      // );
    },
    handleToChange(row) {
      this.changeContent = Object.assign({}, row)
      this.changeDialog = true
    },
    handleSelectionChange(val) {
      this.chooseList = val
    },
  },
}
</script>

<style lang="less" scoped>
.breadcrumb {
  display: flex;
  align-items: center;
  height: 30px;
  justify-content: space-between;
}

.card-header {
  display: flex;
  justify-content: space-between;

  .el-button {
    height: 35px;
    line-height: 10px;
  }
}

.block {
  display: flex;
  margin-bottom: 14px;
  float: right;
  align-items: center;

  .total {
    font-size: 14px;
    margin-right: 8px;
    color: #666;
  }
}

.el-link {
  margin: 0px 5px;
}

.el-input,
.el-select {
  width: 200px;
}
</style>